"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    query getCorpCollectionsService(
        $userId: Int!
        $latitude: Float!
        $longitude: Float!
    ) {
        corpCollections(condition: { userId: $userId }) {
            nodes {
                id: corpCollectionId
                label
                collectionModels {
                    nodes {
                        modelNumber
                        id: corpCollectionModelId
                    }
                }
                models(latitude: $latitude, longitude: $longitude) {
                    lineDescription
                    brandAcronym
                    hasVirtualTour
                    floorPlanReference
                    tags
                    images {
                        mfgModelImageId
                        modelsImagesId
                        modelId
                        isInspired
                        createdBy
                        creationDate
                        lastModifiedBy
                        lastModificationDate
                        isMhAdvantageHome
                        imageId
                        reference
                        caption
                        sortOrder
                        originalUploadedFilename
                        imageType
                        imageTypeAcronym
                        roomId
                        roomDescription
                    }
                    virtualTours {
                        mfgModelVirtualTourId
                        modelId
                        virtualTourId
                        virtualTourReference
                        thumbnailReference
                    }
                    dealers
                    modelId
                    modelNumber
                    modelDescription
                    modelWidth
                    modelLength
                    beds
                    baths
                    maxSquareFeet
                    lowPrice
                    highPrice
                    hasIfp
                    hasDreamHomeDesign
                    startingInThePrice
                    isMhAdvantageHome
                    isPremierFinancingEligible
                }
            }
        }
    }
`;exports.getCorpCollections=e;
//# sourceMappingURL=queries.js.map
